// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"529":"c61d3a1c","544":"437b8cbb","571":"023e7c00","666":"cee5001f","818":"2ce27c14","853":"0af4c9fc"}[chunkId] + ".chunk.js";
};